import React from "react";
import {useAxiosSetup} from "../Api";
import {useModal} from "../dialogs/ModalContext";
import {useNavigate} from "react-router-dom";
import {useAppState} from "../AppStateContext";
import useDebouncedEffect from "./_support/Debouncer";
import {prepareFilters} from "./_support/RequestSupport";


function useTableData(baseUrl, initialFilters, parse_links)  {
    const [data, setData] = React.useState();
    const [links, setLinks] = React.useState();
    const {showModal} = useModal();
    const navigate = useNavigate()
    const api = useAxiosSetup();
    const {appState, updateAppState} = useAppState()


    useDebouncedEffect(() => {
        if (appState.filterPage !== baseUrl) {
            updateAppState({ currentPage: 1, filterPage: baseUrl, filterData: initialFilters });
        } else if (appState.filterData) {
            get_data();
        }
    }, 300, [JSON.stringify(appState)]); // Using JSON.stringify to compare complex objects, note that this is costly for large objects


    function get_data() {
        api.get(baseUrl + '/list_with_links/?format=json', {params: {
                ...prepareFilters(appState.filterData),
                "page": appState.currentPage,
            }}).then((response) => {
            const new_data = JSON.parse(response.data.output)
            setData(new_data)
            const new_links = parse_links(new_data)
            setLinks(new_links)
        })
    }

    function delete_single(index) {
        api.get(baseUrl + '/' + data[index].id + '/delete_single/').then((response) => {
            const newData = data.filter((_, i) => i !== index)
            const newLinks = links.filter((_, i) => i !== index)
            setData(newData)
            setLinks(newLinks)
        })
    }

    function filterUpdate(event) {
        let updatedFilters = appState.filterData
        // Fulltext filter is incompatible with other filters, reset all other filters when it is changed and vice versa
        if (event.target.name === 'Fulltext') {
            updatedFilters.forEach(filter => {
                filter.value = ''
            })} else {
            let fulltextIndex = updatedFilters.findIndex(filter => filter.label === 'Fulltext')
            if (fulltextIndex !== -1)
                updatedFilters[fulltextIndex].value = ''
        }
        // Simple workaround to reset Initial ordering after any filtering change
        let orderingIndex = updatedFilters.findIndex(filter => filter.label === 'ordering')
        if (orderingIndex !== -1 && updatedFilters[orderingIndex].value === 'Initial') {
            updatedFilters[orderingIndex].value = ""
        }
        let index = updatedFilters.findIndex(filter => filter.label === event.target.name)
        let updated = updatedFilters[index]
        if (event.target.name === 'ordering') {
            if (updated.value === event.target.value) {
                updated.value = '-' + event.target.value
            }
            else {
                updated.value = event.target.value
            }
        }
        else {
            updated.value = event.target.value
        }
        updatedFilters[index] = updated
        updateAppState({currentPage: 1, filterData: updatedFilters})
    }


    return [data, appState.filterData, filterUpdate, links, delete_single]
}

export default useTableData
